import { ENV_ENUM } from '@/configProvider';

export const URL = {
    [ENV_ENUM.dev]: 'https://preapi-feedback.meitu.com',
    [ENV_ENUM.pre]: 'https://preapi-feedback.meitu.com',
    [ENV_ENUM.beta]: 'https://betaapi-feedback.meitu.com',
    [ENV_ENUM.release]: 'https://api-feedback.meitu.com',
};

export const eventBusKey = 'xdesign-floatHelp-closeCustomModal';

export type IconSize =
    | 'small'
    | 'large'
    | {
          width: number;
          fontSize: number;
      };

export const sizeConfig = {
    large: {
        width: 42,
        fontSize: 20,
    },
    small: {
        width: 34,
        fontSize: 17,
    },
};

export const feedBackHost = `feedback.meitu.com`;
export const intlFeedBackHost = `feedback.starii.com`;

/** 关闭在线客服事件 */
export const CLOSE_BUSINESS_MESSAGE_MODAL = 'CLOSE_BUSINESS_MESSAGE_MODAL';

/**
 * mode枚举
 */
export enum MODE_ENUM {
    CONTACKMESSAGE = 'ContactMessage',
    FEEBACK = 'FeedBack',
    HELP_CENTER = 'HelpCenter',
    Meidou_Rules = 'MeidouRules',
}
